// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_Lm6","list":"styles_list__lng2x","disableSelection":"styles_disableSelection__3EV2U"};